import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import { jobPostingSchema } from "@/data/careers";
import Careers from "@/pages/Careers";

export const Route = createFileRoute("/_site/careers")({
  head: () => ({
    ...seo({
      title: "Careers | Join Our Crew | Kodiak Structures & Exteriors",
      description:
        "Join the Kodiak Structures & Exteriors crew. We are hiring roofing crews, siding crews and a sales project manager in Minnesota.",
      path: "/careers",
    }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(jobPostingSchema),
      },
    ],
  }),
  component: Careers,
});
